import React from 'react'

const RecipeProductionHeaders = () => {

    return(
        <React.Fragment>
            <th>#</th>
            <th>Gider Adı</th>
            <th>Miktar (USD)</th>
            <th></th>
        </React.Fragment>
    )
}
export default RecipeProductionHeaders